// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__15LM-","MainContent":"App_MainContent__3nN0H","MainNav":"App_MainNav__jAT2S","wrapper":"App_wrapper__RCHjb","overlay":"App_overlay__2FvzF"};